import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=40079d0d&scoped=true&"
import script from "./NotificationList.vue?vue&type=script&lang=ts&"
export * from "./NotificationList.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationList.vue?vue&type=style&index=0&id=40079d0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40079d0d",
  null
  
)

export default component.exports